module.exports = __webpack_public_path__ + "static/img/11.5acbb9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/11.png
// module id = 9x/i
// module chunks = 0